import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SellerEntitiesFactory} from '../Entities/factory.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'
import {UpdateInstantOfferPhoneSellerRequest} from '../Requests/UpdateInstantOfferPhoneSellerRequest.js'

class UpdateInstantOfferPhoneSellerUseCase extends UseCase {
  #config
  #httpRepository
  #localStorageRepository

  constructor({config, httpRepository, localStorageRepository}) {
    super()
    this.#config = config
    this.#httpRepository = httpRepository
    this.#localStorageRepository = localStorageRepository
  }

  static create({config}) {
    return new UpdateInstantOfferPhoneSellerUseCase({
      config,
      httpRepository: SellerRepositoriesFactory.hTTPSellerRepository({config}),
      localStorageRepository: SellerRepositoriesFactory.localStorageSellerRepository({config})
    })
  }

  @tracer({metric: 'UpdateInstantOfferPhoneSellerUseCase#execute'})
  @AsyncInlineError()
  async execute({instantOfferId, phone} = {}) {
    const request = UpdateInstantOfferPhoneSellerRequest.create({config: this.#config, phone})

    const [error] = await this.#httpRepository.updateInstantOfferPhone({instantOfferId, request})

    if (error) throw error

    // Keeps the stored instant offer in sync, as get_instant_offer_by_id_seller_use_case reads it from there
    const [, storedInstantOfferEntity] = await this.#localStorageRepository.getInstantOfferDetails({
      instantOfferEntity: SellerEntitiesFactory.instantOfferSellerEntity({instantOfferId})
    })

    if (!storedInstantOfferEntity) return

    const {contactDetails} = storedInstantOfferEntity.toJSON()

    await this.#localStorageRepository.saveInstantOfferDetails({
      instantOfferEntity: storedInstantOfferEntity,
      contactDetails: {...contactDetails, phone}
    })
  }
}

export const factory = UpdateInstantOfferPhoneSellerUseCase.create
